import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { Provider } from "react-redux"
import { PersistGate } from "redux-persist/integration/react"
import { store, persistor } from "./store"
import App from "./App"
import "./index.css"
import { ThemeProvider } from "./components/theme-provider"
import { AdminAuthProvider } from "./contexts/admin-auth-context"
import { QuestionsProvider } from "./contexts/questions-context"
import { Toaster } from "./components/ui/toaster"

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <AdminAuthProvider>
            <ThemeProvider defaultTheme="dark" storageKey="admin-panel-theme">
              <QuestionsProvider>
                <Toaster />
                <App />
              </QuestionsProvider>
            </ThemeProvider>
          </AdminAuthProvider>
        </PersistGate>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
)
